module.exports = __webpack_public_path__ + "img/collection-weddingRingsTensionRings.0930b3b.jpg";